<template>
  <v-container>
    <v-layout
      justify-center
      text-xs-center
      wrap
      column
    >
      <v-flex xs12 sm8>
        <div class="back_image">
          <h1 class="display-2 font-weight-bold pa-4">
            『ごしゅつい』
          </h1>
          <p class="subheading font-weight-regular pb-4">
            御朱印のツイートと地図を結びつけて<br>ボーッと眺められることを目指したサイトです
            <br>
            <a href="https://ja.wikipedia.org/wiki/%E6%9C%B1%E5%8D%B0_(%E7%A5%9E%E7%A4%BE%E4%BB%8F%E9%96%A3)" target="_blank">Wikipedia:御朱印</a>
            <br>
            <small>
              <strong>
                本サイトの情報は自動で収集したものであるため
                <br>
                間違いなどが含まれている可能性があります
                <br>
                各神社仏閣の公式サイトなどで情報をご確認ください
              </strong>
            </small>
          </p>
        </div>
      </v-flex>
      <v-flex
        mb-5
      >
        <h2 class="headline font-weight-bold mb-1" id="map_head">地図からえらぶ</h2>
        <p class="subheading font-weight-regular pb-1">
          <small>
          アイコン[印]をクリックすると下部にツイートが表示されます<br>
          現在位置に移動したい場合は、左下のボタンをクリック
          </small>
        </p>
        <v-layout justify-center>
          <div id="map" style="width:95%; height:400px"></div>
        </v-layout>
        <v-layout row wrap justify-center>
          <router-view></router-view>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-fab-transition>
      <v-btn
        color="primary"
        dark
        fab
        fixed
        bottom
        right
        @click="scrollToMap"
      >
        <v-icon>map</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        color="secondary"
        dark
        fab
        fixed
        bottom
        left
        @click="setCurrentLocation"
      >
        <v-icon>place</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SpotData from '@/assets/updatedData.json'
// import BackImage from '@/assets/main_backimage.jpg'
import VueScrollTo from 'vue-scrollto'

export default {
  data: () => ({
    // backImage: BackImage,
    spots: SpotData,
    markers: [],
    ymap: null,
    ymapCluster: null
  }),
  computed: {
    ...mapGetters({
      selectedSpot: 'getSelectedSpotData'
    })
  },
  watch: {
    selectedSpot: function (newSpot, oldSpot) {
      this.setSpotLocation()
    }
  },
  methods: {
    resize: function () {
      this.ymap.updateSize()
    },
    clickedMarker: function (spot) {
      console.log(spot)
    },
    renderMap: function () {
      // eslint-disable-next-line
      this.ymap = new Y.Map('map', {
        configure: {
          doubleClickZoom: true,
          scrollWheelZoom: true,
          continuousZoom: true,
          // eslint-disable-next-line
          mapType: Y.Map.TYPE.SMARTPHONE
        }
      })
      // eslint-disable-next-line
      this.ymap.drawMap(new Y.LatLng(35.66572, 139.73100), 14, Y.LayerSetId.NORMAL)
      // eslint-disable-next-line
      this.ymap.addControl(new Y.ZoomControl)
      // eslint-disable-next-line
      this.ymap.addControl(new Y.CenterMarkControl)
      this.spots['spots'].forEach(function (spot) {
        // eslint-disable-next-line
        var icon = new Y.Icon('https://firebasestorage.googleapis.com/v0/b/goshuin-map.appspot.com/o/spot.png?alt=media&token=2a58b0ef-e340-4c06-8c44-c0f5ea2e41a5');
        // eslint-disable-next-line
        const marker = new Y.Marker(new Y.LatLng(spot['place']['coordinates']['latitude'], spot['place']['coordinates']['longitude']),
          { title: spot['name']['written'], icon: icon }
        )
        const instance = this
        marker.bind('click', function () {
          const spotId = spot['id']
          instance.$store.commit('selectSpotData', spotId)
          instance.$router.push({ path: `/spots/${spotId}` })
          instance.$ga.event('Map', 'selectSpot', spot['name']['written'])
        })
        this.ymap.addFeature(marker)
        this.markers.push(marker)
      }, this)
    },
    setCurrentLocation: function () {
      if ('geolocation' in navigator) {
        /* geolocation is available */
        navigator.geolocation.getCurrentPosition((position) => {
          // eslint-disable-next-line
          this.ymap.panTo(new Y.LatLng(position.coords.latitude, position.coords.longitude), true)
          this.scrollToMap()
          this.$ga.event('Tool', 'click', 'getLocation', 1)
        })
      } else {
        /* geolocation IS NOT available */
      }
    },
    scrollToMap: function () {
      VueScrollTo.scrollTo(document.getElementById('map_head'), 500, { offset: -60 })
    },
    setSpotLocation: function () {
      const spot = this.$store.getters.getSelectedSpotData
      console.log(`spot:${spot}`)
      if (spot == null) {
        return
      }
      console.log(`setSpotLocation:${spot}`)
      // eslint-disable-next-line
      this.ymap.panTo(new Y.LatLng(spot['place']['coordinates']['latitude'], spot['place']['coordinates']['longitude']))
    }
  },
  mounted: function () {
    this.$ga.page('/')
    this.$store.commit('setSpotDatas', this.spots['spots'])
    this.renderMap()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style>
.back_image {
  background: linear-gradient(rgba(0,0,0,.7), rgba(0,0,0,.9)),
    url("../../static/main_backimage.jpg");
  background-size: cover;
}
#spotInfo {
  padding-top: 16px
}
.yolp-ymapbanner {
  display: none
}
.yolp-logo {
  z-index: 0 !important;
}
.yolp-centermark {
  z-index: 0 !important;
}
.yolp-tlchp {
  color:black
}
</style>
